import styles from './index.module.scss'

export function FormControl({ gap = '0.5rem', children }) {
  return (
    <div style={{ gap }} className={styles.box}>
      {children}
    </div>
  )
}
